import { render, staticRenderFns } from "./reject-offer.vue?vue&type=template&id=8c493f5a&scoped=true"
import script from "./reject-offer.vue?vue&type=script&lang=js"
export * from "./reject-offer.vue?vue&type=script&lang=js"
import style0 from "./reject-offer.vue?vue&type=style&index=0&id=8c493f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c493f5a",
  null
  
)

export default component.exports